export default __webpack_public_path__ + "static/media/December2018.d4d8ac3a.png";